import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { SelectionTexto } from "../models/SelectionTexto";
import { EnumModoSelecao } from "../enums/EnumModoSelecao";

@Injectable()
export class SelectionService {
  public selection: SelectionTexto = new SelectionTexto();
  private selection$ = new BehaviorSubject<SelectionTexto>(this.selection);

  constructor() {}

  public getSelectionValue() {
    return this.selection;
  }

  atualizar(selection: SelectionTexto) {
    this.selection.modo = selection.modo ?? this.selection.modo;
    this.selection.selector = selection.selector ?? this.selection.selector;
    this.selection.tipo = selection.tipo ?? this.selection.tipo;
    this.updateSelection();
  }

  resetaSelector() {
    this.selection.selector = null;

    this.updateSelection();
  }

  resetaSelection() {
    this.selection.selector = null;
    this.selection.modo = EnumModoSelecao.Padrao;
    this.selection.tipo = null;
    this.updateSelection();
  }

  updateSelection() {
    this.selection$.next(this.selection);
  }

  getSelection(): Observable<SelectionTexto> {
    return this.selection$.asObservable();
  }
}
